import React from 'react';
import './drinks.scss';
import {Col, Container, Row} from 'react-bootstrap';


function Drinks() {
  return (
    <div id="drinks" className="our-drinks pt50">
      <Container>
      <Row>
          <Col sm={12} className="mb50">
            <div className="section-title">Drinks & Refreshments</div>
            <h2>Drinks in the Garden</h2>
              <div className="p-sides">
                  <div className="subtitle">
                      We offer a selection of wine, beer, soft drinks, bottled water, energy drinks, fresh juices, tea,
                      coffee and light snacks for your convenience.
                  </div>
                  <div className="subtitle">
                      You're also welcome to bring your own wine, beer or champagne to enjoy during your stay.
                  </div>
                  <div className="subtitle">
                      To help maintain a peaceful atmosphere, we kindly ask guests to avoid bringing large quantities of
                      strong spirits such as vodka, whisky, tequila, gin or zivania. One bottle for personal use is
                      perfectly fine.
                      <br/><br/>
                      *Planning a private event? Please contact us in advance and we'll be happy to
                      discuss the arrangements.
                  </div>
              </div>
          </Col>
      </Row>
      </Container>
    </div>
  )
}

export default Drinks;
